/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ad_Output_Language_HelpInputs */

const en_ad_output_language_help = /** @type {(inputs: Ad_Output_Language_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The language the AI will use to write the description text.`)
};

const fr_ad_output_language_help = /** @type {(inputs: Ad_Output_Language_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le langage que l'IA utilisera pour rédiger le texte descriptif.`)
};

const de_ad_output_language_help = /** @type {(inputs: Ad_Output_Language_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Sprache, die die KI zum Schreiben des Beschreibungstextes verwenden wird.`)
};

const it_ad_output_language_help = /** @type {(inputs: Ad_Output_Language_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La lingua che l'IA utilizzerà per scrivere il testo descrittivo.`)
};

const ru_ad_output_language_help = /** @type {(inputs: Ad_Output_Language_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Язык, который ИИ будет использовать для написания описательного текста.`)
};

const es_ad_output_language_help = /** @type {(inputs: Ad_Output_Language_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El idioma que la IA utilizará para escribir el texto descriptivo.`)
};

const zh_cn2_ad_output_language_help = /** @type {(inputs: Ad_Output_Language_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`人工智能将用于编写描述文本的语言。`)
};

const ja_ad_output_language_help = /** @type {(inputs: Ad_Output_Language_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AIが説明文を作成する際に使用する言語。`)
};

const hi_ad_output_language_help = /** @type {(inputs: Ad_Output_Language_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`वह भाषा जिसका उपयोग एआई विवरण लिखने के लिए करेगा।`)
};

const pt_pt2_ad_output_language_help = /** @type {(inputs: Ad_Output_Language_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O idioma que a IA usará para escrever o texto descritivo.`)
};

/**
* | output |
* | --- |
* | "The language the AI will use to write the description text." |
*
* @param {Ad_Output_Language_HelpInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ad_output_language_help = /** @type {((inputs?: Ad_Output_Language_HelpInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ad_Output_Language_HelpInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_ad_output_language_help(inputs)
	if (locale === "de") return de_ad_output_language_help(inputs)
	if (locale === "it") return it_ad_output_language_help(inputs)
	if (locale === "ru") return ru_ad_output_language_help(inputs)
	if (locale === "es") return es_ad_output_language_help(inputs)
	if (locale === "zh-CN") return zh_cn2_ad_output_language_help(inputs)
	if (locale === "ja") return ja_ad_output_language_help(inputs)
	if (locale === "hi") return hi_ad_output_language_help(inputs)
	if (locale === "pt-PT") return pt_pt2_ad_output_language_help(inputs)
	return en_ad_output_language_help(inputs)
});